import { Empty } from 'antd';
import groupBy from 'lodash/groupBy';
import React, { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { TemplateRating } from 'api/reports/csat';
import { Widget } from '../widget';
import { Chart } from './chart';

interface Props {
  data?: TemplateRating[];
  isLoading?: boolean;
}

export const TemplateRatings: FC<Props> = ({ data = [], isLoading }) => {
  const intl = useIntl();
  const getData = (_data: TemplateRating[]) => {
    const templates = _data
      .map((d) => d.projectTemplate)
      .reduce((obj, next) => {
        return {
          ...obj,
          [next.templateId]: next,
        };
      }, {});
    const grouped = groupBy(_data, 'projectTemplate.templateId');
    const templateIds = Object.keys(grouped);

    const categories = templateIds.map((id) => templates[id].templateName);

    const series = Array.from({ length: 5 }, (_, i) => i + 1).map((rating) => ({
      name: intl.formatMessage({ id: `csat.rating.${rating}` }),
      data: templateIds.map((id) => {
        const result = grouped[id].find((t) => t.rating === rating);

        return result ? result.count : 0;
      }),
    }));

    return {
      categories,
      series,
    };
  };

  return (
    <Widget
      loading={isLoading}
      title={<FormattedMessage id="csat.widget.heading.template" />}
    >
      {data.length > 0 ? <Chart data={getData(data)} /> : <Empty />}
    </Widget>
  );
};
